import React from 'react';

const ArrowRightIcon = ({size}) => (
  <svg width={size} height={size} fill="none" viewBox={'0 0 24 24'}>
    <path fill="currentColor"
          fillRule="evenodd"
          d="M18.88 11.35 12.95 5.4 14.36 4l8.35 8.35-8.35 8.34-1.41-1.41 5.93-5.93H1.29v-2h17.59Z"
          clipRule="evenodd"
    />
  </svg>
);

export default ArrowRightIcon;
